<template>
  <div v-if="post_detail" class="h-full">
    <div class="preview-main" :style="main_style"  v-if="showGame">
      <div v-if="prizeItem" class="scratch">
        <div class="scratch-area">
          <div class="scratch-company-logo">
            <img class="mx-auto" :src="getdataImg(post_detail.logo_id)" /></div>
            <scratch-surface :completed="setPlayed"
                           :showinfo="setHalf"
                           :loaded="scratchLoaded"
                           :image_url="getdataImg(prizeItem.image_id)"
                           code="{CODE}" :headline="prizeItem.name"
                           id="scratchoff"
                           :show-scratch="showPrizePlaceholder"
                           :show-congrats-preview="showCongratsPlaceholder"
                           :getPercentageCleared="true"
                           :percentageStride="100" class="scratch-off"
                           :brushOptions="{size: 30}"
                           :hideOptions="{src: scratch_cover_bg ,type: 'pattern', repeat: 'repeat', size: 'cover'}">
            <div v-if="!showPrize" class="scratch-blocker"></div>
            <div v-else class="content-so flex" ref="congrats" :style="scratch_bg">
              <h2 v-if="prizeItem.text_enabled" :style="congrats_style">Congratulations!</h2>
              <h3 v-if="prizeItem.text_enabled">{{ prizeItem.name }}</h3>
              <img :src="getdataImg(prizeItem.image_id)" />
            </div>
          </scratch-surface>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueScratchable from 'vue-scratchable'
import ScratchSurface from '../../components/ScratchSurface'
export default {
  name: 'ScratchPreview',
  props: {
    showPrizePlaceholder: {
      type: Boolean
    },
    showCongratsPlaceholder: {
      type: Boolean
    },
    previewPrize: {
      type: Object,
      defualt: null
    }
  },
  data () {
    return {
      showGame: true,
      fieldnames: [
        {
          name: 'Name',
          code: 'name',
          value: false
        },
        {
          name: 'Phone Number',
          code: 'phone',
          value: false
        },
        {
          name: 'Email',
          code: 'email',
          value: false
        },
        {
          name: 'Birthday',
          code: 'birthday',
          value: false
        },
        {
          name: 'Address',
          code: 'address',
          value: false
        }
      ],
      name: '',
      email: '',
      birthday: '',
      phone: '',
      address: '',
      setupTime: new Date().getTime().toString(),
      nowTime: new Date().getTime(),
      sessiomInterval: null,
      sessionid: (localStorage.getItem('sessionid') && localStorage.getItem('sessionid') !== 'undefined') ? localStorage.getItem('sessionid') : this.makeid(25)
    }
  },
  components: {
    VueScratchable,
    ScratchSurface
  },
  mounted () {
    console.log('scratch preview', this.post_detail)
  },
  destroyed () {
  },
  watch: {
    showGame () {
      if (!this.showGame) {
        setTimeout(() => {
          this.showGame = true
        }, 1500)
      }
    },
    campaign_theme () {
      this.showGame = false
    }
  },
  computed: {

    congrats_style () {
      if (this.campaign_theme) {
        if (this.campaign_theme.congrats) {
          return `color: ${this.campaign_theme.congrats.color}; font-size: ${this.campaign_theme.congrats.size}px; font-weight: ${this.campaign_theme.congrats.weight};`
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    main_style () {
      if (this.campaign_theme) {
        if (this.isObject(this.campaign_theme.main)) {
          return `background: url(${this.getImage(this.campaign_theme.main.url)})`
        } else if (this.campaign_theme.main !== '') {
          return `background: ${this.campaign_theme.main}`
        }
      }
      return ''
    },
    scratch_bg () {
      if (this.campaign_theme) {
        if (this.isObject(this.campaign_theme.scratch) && this.campaign_theme.scratch.url !== '') {
          return `background: url(${this.getImage(this.campaign_theme.scratch.url)})`
        } else if (this.campaign_theme.scratch !== '') {
          return `background: ${this.campaign_theme.scratch}`
        } else {
          return 'background: url("/scratchBack.jpeg")'
        }
      } else {
        return 'background: url("/scratchBack.jpeg")'
      }
    },
    scratch_cover_bg () {
      return this.campaign_theme ? (this.campaign_theme.cover ? this.getImage(this.campaign_theme.cover) : '/default_scratch_texture.jpg') : '/default_scratch_texture.jpg'
    },
    campaign_theme () {
      return this.$store.state.campaign_theme
    },
    prizeItem () {
      return this.previewPrize ? this.previewPrize : this.post_detail.prizeList[Math.floor(Math.random() * this.post_detail.prizeList.length)]
    },
    post_detail () {
      return this.$store.state.post_detail
    },
    timeDiff () {

      let msec = this.nowTime - this.setupTime
      const hh = Math.floor(msec / 1000 / 60 / 60)
      msec -= hh * 1000 * 60 * 60
      const mm = Math.floor(msec / 1000 / 60)
      msec -= mm * 1000 * 60
      const ss = Math.floor(msec / 1000)
      msec -= ss * 1000

      return `${hh}:${mm}:${ss}`

      //return msec
    },
    showPrize () {
      let result = false

      if (this.post_detail.prizeList.length > 0) {
        result = true
      }

      return result
    }
  },
  methods: {
    scratchLoaded () {
      console.log('scratch loaded', this.$parent)
      if (this.$parent.init) {
        this.$parent.preview_switch = false
        this.$parent.init = false
      }
    },
    isObject (a) {
      return (!!a) && (a.constructor === Object)
    },
    getImage (url) {
      return `https://restapi.authorizelocal.com/api/posts/photo/${url}`
    },
    setHalf () {},
    setPlayed () {
      /*
      const payload = {
        code: this.slug
      }
      this.$store.dispatch('setPlayed', payload)
        .then((response) => {
          console.log('success')
          console.log(response)
          //location.reload()
        })
        .catch(error => {
          this.$vs.loading.close()
          console.log('error')
          console.log(error)
        })*/
    },
    makeid (length) {
      let result = ''
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      const charactersLength = characters.length
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result
    },
    open_link (url) {
      window.open(url, '_blank')
    },
    checkSessionValid () {
      this.nowTime = new Date().getTime()
      let msec = this.nowTime - this.setupTime
      const hh = Math.floor(msec / 1000 / 60 / 60)
      msec -= hh * 1000 * 60 * 60
      const mm = Math.floor(msec / 1000 / 60)
      msec -= mm * 1000 * 60
      const ss = Math.floor(msec / 1000)
      msec -= ss * 1000

      console.log(`diff${msec}`, this.timeDiff)
      console.log('prize', this.prizeItem.name)
      if (hh === 0 && mm >= 30) {
        this.refreshSession()
      }

      if (!this.sessiomInterval) {
        this.sessiomInterval = setInterval(this.checkSessionValid, 1000 * 60)
      }

    },
    refreshSession () {
      console.log('refresing session')

      localStorage.removeItem('prize')
      localStorage.removeItem('session')
      localStorage.removeItem('setup')

      location.reload()
    },
    setupData () {
      this.prizeItem = this.post_detail.interaction.prize
    },
    getdataImg (id) {
      return `https://restapi.authorizelocal.com/api/posts/photo/${id}`
    }
  }
}
</script>
<style lang="scss">
.scratch-blocker {
  position: absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  z-index:3;
}
.submit-description {
  text-align:center;
  font-size:14px;
  font-weight:bold;
  margin-bottom:20px;
}
.already-played {
  width:100%;
  min-height: 100vh;
  display:flex;
  justify-content: center;
  align-items: center;
}
.denied{
  i {
    color:#c32429;
    font-size:42px;
  }
}
.short-message {
  h2{
    text-align: center;
  }
  display:flex;
  justify-content: center;
  align-items:center;
  font-size:32px;
  font-weight: 700;
  width:90%;
  padding:50px 20px;
  border-radius: 7px;
}
.preview-main {
  width: 100%;
  height: 100%;
}
</style>
